import { CATEGORY_HELPER } from '@/modules/lab/catalog/catalogConstants'
import {
  buildCategorySelectorGroups,
  buildSpecimenSelectorGroups,
} from '@/modules/lab/catalog/selectorBuilders'
import type { CatalogInvestigationRow } from '@/modules/lab/catalog/types'

/** @deprecated Use buildCategorySelectorGroups + CategorySelectorField */
export const buildCategoryGroups = buildCategorySelectorGroups

/** @deprecated Use buildSpecimenSelectorGroups + SpecimenSelectorField */
export const buildSpecimenGroups = buildSpecimenSelectorGroups

export function getPopularTests(rows: CatalogInvestigationRow[]): CatalogInvestigationRow[] {
  const enabled = rows.filter((r) => r.hospitalEnabled && r.activeFlag === 'A' && !r.isDraft)
  const score = (r: CatalogInvestigationRow) => {
    let s = 0
    if (r.hospitalEnabled) s += 2
    if (!r.isLocal) s += 1
    if (r.aliases.length > 0) s += 1
    return s
  }
  return [...enabled].sort((a, b) => score(b) - score(a) || a.displayName.localeCompare(b.displayName)).slice(0, 8)
}

export function categoryHelperFor(value: string): string | undefined {
  if (!value) return 'Required — pick the clinical department for this test'
  return CATEGORY_HELPER[value] ?? undefined
}
